import img1 from "../assets/images/categories/STARTERS.jpg";
import img2 from "../assets/images/categories/bbq chicken.jpg";
import img3 from "../assets/images/categories/SALADS.png";
import img4 from "../assets/images/categories/burgers.png";
import img5 from "../assets/images/categories/SANDWICHES.jpg";
import img6 from "../assets/images/categories/pasta.png";
import img7 from "../assets/images/categories/dessert1.png";
import img8 from "../assets/images/categories/COFFEE.jpg";
import img9 from "../assets/images/categories/iced-tea.jpg";
import img10 from "../assets/images/categories/cold coffe.jpg";
import img11 from "../assets/images/categories/TEA.jpg";
// import img12 from "../assets/images/categories/BUBBLE TEA.jpg";
import img13 from "../assets/images/categories/MOJITO.jpg";
import img14 from "../assets/images/categories/sizzlers.png";
import img15 from "../assets/images/categories/FRESH JUICE.png";
import img16 from "../assets/images/categories/FRUITS FREEZE.jpg";
import img17 from "../assets/images/categories/MILK SHAKES.jpg";
import img18 from "../assets/images/categories/tender coconut.png";
import img19 from "../assets/images/categories/Wraps.jpg";
import img20 from "../assets/images/categories/pizza.png";
import img21 from "../assets/images/categories/ABC Juice.jpeg";
import img22 from "../assets/images/categories/Cakes.jpeg";
import img23 from "../assets/images/categories/FALOODA.jpeg";
import img24 from "../assets/images/categories/Steak.jpeg";
import img25 from "../assets/images/categories/ZAD SPECIALS.jpeg";
import img26 from "../assets/images/categories/coffeeRock.png";

export const menu = [
   {
    id: 1,
    title: "FRESH JUICE",
    category: "FRESH JUICE",
    dir: { section: "ltr", inner: "ltr" },
    image: img15,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "PINEAPPLE", price: "90", description: "" },
      { id: 2, name: "WATERMELON", price: "80", description: "" },
      { id: 3, name: "GRAPES", price: "90", description: "" },
      { id: 4, name: "ORANGE", price: "110", description: "" },
      { id: 5, name: "MINT LIME", price: "80", description: "" },
    ],
  },
  {
    id: 2,
    title: "HEALTHY JUICE",
    category: "HEALTHY JUICE",
    dir: { section: "rtl", inner: "ltr" },
    image: img21,
    bgImage: { bg1: "", bg2: "" },
    items: [
      {
        id: 1,
        name: "ABC JUICE",
        price: "140",
        description: "",
        recipe: "(Apple, Beetroot, Carrot)",
      },
      {
        id: 2,
        name: "TROPICAL SPLASH",
        price: "160",
        description: "",
        recipe: "(Carrot,Apple,Orange,Ginger)",
      },
    ],
  },
  {
    id: 3,
    title: "MOJITO",
    category: "MOJITO",
    dir: { section: "ltr", inner: "ltr" },
    image: img13,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "WATER MELON MOJITO", price: "180", description: "" },
      { id: 2, name: "GREEN APPLE MOJITO", price: "180", description: "" },
      { id: 3, name: "PASSION FRUIT MOJITO", price: "180", description: "" },
      { id: 4, name: "SEA BLUE MOJITO", price: "190", description: "" },
    ],
  },
  {
    id: 4,
    title: "ICE CREAM SHAKES",
    category: "ICE CREAM SHAKES",
    dir: { section: "rtl", inner: "ltr" },
    image: img17,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "BUTTERSCOTCH", price: "160", description: "" },
      { id: 2, name: "STRAWBERRY", price: "140", description: "" },
      { id: 3, name: "VANILLA", price: "130", description: "" },
      { id: 4, name: "MANGO", price: "150", description: "" },
      { id: 5, name: "OREO", price: "150", description: "" },
      { id: 6, name: "LOTUS BISCOFF SHAKE", price: "220", description: "" },
    ],
  },
  {
    id: 5,
    title: "TEA POT",
    category: "TEA POT",
    dir: { section: "ltr", inner: "ltr" },
    image: img11,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "BLACK TEA", price: "50", description: "" },
      { id: 2, name: "LEMON TEA", price: "70", description: "" },
      { id: 3, name: "MINT TEA", price: "70", description: "" },
      { id: 4, name: "HONEY GINGER TEA", price: "180", description: "" },
      { id: 5, name: "GREEN TEA", price: "90", description: "" },
      { id: 6, name: "ARABIC QAHWA WITH DATES", price: "280", description: "" },
      { id: 7, name: "LEMON ICED TEA", price: "140", description: "" },
      { id: 8, name: "MINT ICED TEA", price: "140", description: "" },
    ],
  },
  {
    id: 6,
    title: "COFFEE CORNER",
    category: "COFFEE CORNER",
    dir: { section: "rtl", inner: "ltr" },
    image: img26,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "ESPRESSO", price: "80", description: "" },
      { id: 2, name: "AMERICANO", price: "100", description: "" },
      { id: 3, name: "CAPPUCCINO", price: "130", description: "" },
      { id: 4, name: "CAFE LATTE", price: "120", description: "" },
      { id: 5, name: "HOT CHOCOLATE", price: "140", description: "" },
      { id: 6, name: "CAFE MOCHA", price: "180", description: "" },
      { id: 7, name: "HOT CARAMEL", price: "150", description: "" },
      { id: 8, name: "SPANISH LATTE", price: "170", description: "" },
      { id: 9, name: "IRISH COLD COFFEE", price: "250", description: "" },
      { id: 10, name: "ICED CARAMEL FRAPPE", price: "250", description: "" },
      { id: 11, name: "ICED AMERICANO", price: "160", description: "" },
      { id: 12, name: "COFFEE FRAPPE", price: "260", description: "" },
    ],
  },
  {
    id: 7,
    title: "STARTERS",
    category: "STARTERS",
    dir: { section: "ltr", inner: "ltr" },
    image: img2,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "CHICKEN POPCORN", price: "220", description: "" },
      { id: 2, name: "CHICKEN STRIPS (06 pcs)", price: "240", description: "" },
      {
        id: 3,
        name: "BBQ CHICKEN WINGS (06 pcs)",
        price: "240",
        description: "",
      },
      { id: 4, name: "DYNAMITE CHICKEN", price: "240", description: "" },
      {
        id: 5,
        name: "CHICKEN CHEESE BALL (08 pcs)",
        price: "280",
        description: "",
      },
      {
        id: 6,
        name: "CHICKEN NUGGETS (08 pcs)",
        price: "180",
        description: "",
      },
      {
        id: 7,
        name: "VEG SPRING ROLL (04 pcs)",
        price: "200",
        description: "",
      },
      { id: 8, name: "PRAWN TEMPURA (06 pcs)", price: "360", description: "" },
      { id: 9, name: "CHEESY STUFFED CHICKEN", price: "290", description: "" },
    ],
  },

  {
    id: 8,
    title: "FRIES",
    category: "FRIES",
    dir: { section: "rtl", inner: "ltr" },
    image: img1,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "FRENCH FRIES", price: "110", description: "" },
      { id: 2, name: "PERI PERI FRIES", price: "140", description: "" },
      {
        id: 3,
        name: "LOADED CHICKEN/BEEF FRIES",
        price: "280/290",
        description: "",
      },
    ],
  },

  {
    id: 9,
    title: "ZAD SPECIALS",
    category: "ZAD SPECIALS",
    dir: { section: "ltr", inner: "ltr" },
    image: img25,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "BUN SOUP", price: "220", description: "" },
      { id: 2, name: "CHICKEN SHASHLIK", price: "350", description: "" },
      {
        id: 3,
        name: "STUFFED BUN WITH CREAM SAUCE ",
        price: "380",
        description: "",
        recipe: "(Chicken/Beef)",
      },
      { id: 4, name: "COUNTRY FRIED CHICKEN", price: "380", description: "" },
      {
        id: 5,
        name: "TURKISH CILANTRO RICE BOWL",
        price: "390",
        description: "",
      },
      { id: 6, name: "ZAD PARATHA BURGER", price: "150", description: "" },
    ],
  },
  {
    id:10,
    title: "SALADS",
    category: "SALADS",
    dir: { section: "rtl", inner: "ltr" },
    image: img3,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "CAESAR SALAD CHICKEN", price: "240", description: "" },
      { id: 2, name: "MEXICAN CHICKEN SALAD", price: "280", description: "" },
      { id: 3, name: "SWEET MANGO SALAD", price: "280", description: "" },
      { id: 4, name: "ARABIC VEG SALAD", price: "220", description: "" },
      { id: 5, name: "ROAST BEEF SALAD", price: "280", description: "" },
    ],
  },

  {
    id: 11,
    title: "BURGER",
    category: "BURGER",
    dir: { section: "ltr", inner: "ltr" },
    image: img4,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "GRILLED CHICKEN BURGER", price: "220", description: "" },
      { id: 2, name: "CHEESE CHICKEN BURGER", price: "290", description: "" },
      { id: 3, name: "ZINGER CHICKEN BURGER", price: "240", description: "" },
      {
        id: 4,
        name: "SMASH CHICKEN/BEEF BURGER",
        price: "370",
        description: "",
      },
      {
        id: 5,
        name: "SWISS CHEESE BEEF BURGER",
        price: "390",
        description: "",
      },
    ],
  },

  {
    id: 12,
    title: "SANDWICH",
    category: "SANDWICH",
    dir: { section: "rtl", inner: "ltr" },
    image: img5,
    bgImage: { bg1: "", bg2: "" },
    items: [
      {
        id: 1,
        name: "CLUB SANDWICH VEG/CHICKEN",
        price: "180/220",
        description: "",
      },
      {
        id: 2,
        name: "GRILLED CHICKEN SANDWICH",
        price: "250",
        description: "",
      },
      {
        id: 3,
        name: "TANDOORI CHICKEN SANDWICH",
        price: "280",
        description: "",
      },
    ],
  },

  {
    id: 13,
    title: "WRAPS",
    category: "WRAPS",
    dir: { section: "ltr", inner: "ltr" },
    image: img19,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "CLASSIC CHICKEN WRAP", price: "200", description: "" },
      { id: 2, name: "ZINGER CHICKEN WRAP", price: "240", description: "" },
      { id: 3, name: "MEXICAN CHICKEN WRAP", price: "240", description: "" },
      { id: 4, name: "PERI PERI CHICKEN WRAP", price: "240", description: "" },
    ],
  },

  {
    id: 14,
    title: "PASTA",
    category: "PASTA",
    dir: { section: "rtl", inner: "ltr" },
    image: img6,
    bgImage: { bg1: "", bg2: "" },
    items: [
      {
        id: 1,
        name: "ALFREDO VEG/CHICKEN PASTA",
        price: "250/300",
        description: "",
      },
      {
        id: 2,
        name: "SALSA ROSA PASTA CHICKEN",
        price: "320",
        description: "",
      },
      {
        id: 3,
        name: "ARRABBIATA CHICKEN PASTA",
        price: "320",
        description: "",
      },
      {
        id: 4,
        name: "SPAGHETTI / PENNE BOLOGNESE (BEEF)",
        price: "380",
        description: "",
      },
    ],
  },

  {
    id: 15,
    title: "STEAK",
    category: "STEAK",
    dir: { section: "ltr", inner: "ltr" },
    image: img24,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "IRON CHICKEN STEAK", price: "360", description: "" },
      { id: 2, name: "STEAK DIANE", price: "390", description: "" },
      {
        id: 3,
        name: "STROGANOFF CHI/BEEF SIZZLER",
        price: "450/490",
        description: "",
      },
      {
        id: 4,
        name: "STEAK ROSSINI CHI/BEEF",
        price: "450/490",
        description: "",
      },
    ],
  },

  {
    id: 16,
    title: "PIZZA",
    category: "PIZZA",
    dir: { section: "rtl", inner: "ltr" },
    image: img20,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "BBQ CHICKEN PIZZA", price: "380", description: "" },
      { id: 2, name: "PHILLY BEEF PIZZA", price: "480", description: "" },
      { id: 3, name: "CLASSIC MARGHERITA", price: "320", description: "" },
    ],
  },
 
  {
    id: 17,
    title: "FALOODA / FRUIT SALAD",
    category: "FALOODA / FRUIT SALAD",
    dir: { section: "ltr", inner: "ltr" },
    image: img23,
    bgImage: { bg1: "", bg2: "" },
    items: [
      { id: 1, name: "ROYAL FALOODA", price: "220", description: "" },
      { id: 2, name: "ZAD SPECIAL FALOODA", price: "260", description: "" },
      { id: 3, name: "MINI FALOODA", price: "160", description: "" },
      { id: 4, name: "NATURAL NEST", price: "140", description: "" },
      { id: 5, name: "SPECIAL FRUIT SALAD", price: "180", description: "" },
    ],
  },
  {
    id: 18,
    title: "CAKES",
    category: "CAKES",
    dir: { section: "rtl", inner: "rtl" },
    image: img22,
    bgImage: { bg1: "", bg2: "" },
    items: [
      {
        id: 1,
        name: "FRESH CREAM CAKES ARE AVAILABLE HERE",
        description: "",
        recipe: "Ask staff for flavours",
      },
    ],
  },
];
